import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-two',
  templateUrl: './dashboard-two.component.html',
  styleUrls: ['./dashboard-two.component.css']
})
export class DashboardTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
